;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { clsx } from 'clsx/lite'

const formatStepLabel = (template: string, current: number, total: number, label: string) =>
  template.replace('{current}', String(current)).replace('{total}', String(total)).replace('{label}', label)

export function RegisterStepProgress({
  current,
  total,
  label,
  template,
}: {
  current: number
  total: number
  label: string
  template: string
}) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {Array.from({ length: total }).map((_, index) => (
          <span
            key={index}
            aria-hidden="true"
            className={clsx(
              'h-1 flex-1 rounded-full transition-colors duration-300',
              index <= current ? 'bg-accent' : 'bg-mist-950/10 dark:bg-white/15',
            )}
          />
        ))}
      </div>
      <p className="text-xs font-semibold text-mist-500 dark:text-mist-400">
        {formatStepLabel(template, current + 1, total, label)}
      </p>
    </div>
  )
}
